// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessSpanner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.33 2.933A5.084 5.084 0 0 1 8.387 2.5c2.916 0 5.28 2.462 5.28 5.5 0 .427-.047.844-.135 1.244l7.364 7.665c.469.488.47 1.28 0 1.768l-2.259 2.353a1.166 1.166 0 0 1-1.697 0l-7.358-7.671a5.089 5.089 0 0 1-1.195.141c-2.916 0-5.28-2.462-5.28-5.5 0-.758.148-1.483.416-2.143.352-.864 1.38-.963 1.935-.385l2.029 2.114.503-.524-2.03-2.114c-.554-.578-.46-1.649.37-2.015zm1.919 1.57 1.608 1.675c.468.488.468 1.28 0 1.768L8.335 9.53a1.166 1.166 0 0 1-1.697 0L5.03 7.855A3.73 3.73 0 0 0 5.027 8c0 1.933 1.505 3.5 3.36 3.5.405 0 .79-.074 1.145-.208l.574-.216 7.683 8.01 1.24-1.293L11.34 9.79l.208-.598c.129-.37.2-.77.2-1.192 0-1.933-1.505-3.5-3.36-3.5-.047 0-.093.001-.14.003z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessSpanner;
